import React from "react";
import LogoImage from "../../images/logo.png";

import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

export const Logo = ({ onClickCallback, ...props }) => {
  const navigate = useNavigate();

  const onLogoClick = () => {
    navigate("/");
    onClickCallback?.();
  };

  return (
    <Box
      component="img"
      src={LogoImage}
      sx={{
        width: "109px",
        height: "24.5px",
      }}
      onClick={onLogoClick}
      {...props}
    />
  );
};
